import moment from "moment";
import { newTagAmountOfDays } from "../components/Tag/newTagFilter";

/*
 * Returns true if the given track is within the "New" window
 * (see newTagAmountOfDays). Accepts either a browse-shape track
 * (with `publishDate`) or an editor-shape track (with `createdAt`),
 * and tolerates ISO strings, Date objects, and unix-ms strings.
 */
export const isNewTrack = track => {
  if (!track) return false;
  const raw = track.publishDate ?? track.createdAt;
  if (!raw) return false;
  let m = moment(raw);
  if (!m.isValid()) m = moment(raw, "x");
  if (!m.isValid()) return false;
  return m.isAfter(moment().subtract(newTagAmountOfDays, "days"));
};
